export default __webpack_public_path__ + "static/media/element_51.ffb1443b.webp";